export const Occasion = {
  BIRTHDAY: "birthday",
  REHEARSAL_DINNER: "rehearsal_dinner",
  WEDDING: "wedding",
  RETIREMENT: "retirement_party",
  ANNIVERSARY: "anniversary",
  CORPORATE: "corporate_event",
  BACK_YARD_PARTY: "back_yard_party",
  CELEBRATION_OF_LIFE: "celebration_of_life",
  SCHOOL_EVENT: "school_event",
  HOLIDAY: "holiday_party",
  BABY_SHOWER: "baby_shower",
  OTHER: "other"
};

export const OCCASIONS = {
  [Occasion.BIRTHDAY]: {
    value: Occasion.BIRTHDAY,
    label: "Birthday",
  },
  [Occasion.REHEARSAL_DINNER]: {
    value: Occasion.REHEARSAL_DINNER,
    label: "Rehearsal Dinner",
  },
  [Occasion.WEDDING]: {
    value: Occasion.WEDDING,
    label: "Wedding",
  },
  [Occasion.RETIREMENT]: {
    value: Occasion.RETIREMENT,
    label: "Retirement Party",
  },
  [Occasion.ANNIVERSARY]: {
    value: Occasion.ANNIVERSARY,
    label: "Anniversary",
  },
  [Occasion.CORPORATE]: {
    value: Occasion.CORPORATE,
    label: "Corporate Event",
  },
  [Occasion.BACK_YARD_PARTY]: {
    value: Occasion.BACK_YARD_PARTY,
    label: "Back Yard Party",
    description: "Throwing a Backyard Taco Party? Let's Make It Unforgettable!"
  },
  [Occasion.CELEBRATION_OF_LIFE]: {
    value: Occasion.CELEBRATION_OF_LIFE,
    label: "Celebration of Life",
  },
  [Occasion.SCHOOL_EVENT]: {
    value: Occasion.SCHOOL_EVENT,
    label: "School Event",
  },
  [Occasion.HOLIDAY]: {
    value: Occasion.HOLIDAY,
    label: "Holiday Party",
  },
  [Occasion.BABY_SHOWER]: {
    value: Occasion.BABY_SHOWER,
    label: "Baby Shower",
  },
  [Occasion.OTHER]: {
    value: Occasion.OTHER,
    label: "Other",
  },
};

// Helper function to get occasion label by value
export const getOccasionLabel = (value) => {
  return OCCASIONS[value]?.label || value || 'Unknown';
};

// Helper function to get all occasions as options for select dropdowns
export const getOccasionOptions = () => {
  return Object.values(OCCASIONS).map(occasion => ({
    title: occasion.label,
    value: occasion.value
  }));
}; 